export default __webpack_public_path__ + "static/media/serojaCycloneEng.0d389a9d.jpg";